export const isLoadingSignIn = state => (state.auth.signin.isLoading)
export const errorSignIn = state => (state.auth.signin.error)
export const successSignIn = state => (state.auth.signin.success)

export const isLoadingSignInProtocol = state => (state.auth.signinProtocol.isLoading)
export const errorSignInProtocol = state => (state.auth.signinProtocol.error)

export const isLoadingSignInValidateDoc = state => (state.auth.signinValidateDoc.isLoading)
export const errorSignInValidateDoc = state => (state.auth.signinValidateDoc.error)
export const receivedAtSignInValidateDoc = state => (state.auth.signinValidateDoc.receivedAt)
export const validateDoc = state => (state.auth.signinValidateDoc.data)

export const isLoadingSignUpVerify = state => (state.auth.signupVerify.isLoading)
export const errorSignUpVerify = state => (state.auth.signupVerify.error)
export const successSignUpVerify = state => (state.auth.signupVerify.success)

export const isLoadingSignUp = state => (state.auth.signup.isLoading)
export const errorSignUp = state => (state.auth.signup.error)
export const successSignUp = state => (state.auth.signup.success)

export const isLoadingPlans = state => (state.auth.plans.isLoading)
export const plans = state => (state.auth.plans.data)

export const isLoadingPlan = state => (state.auth.plan.isLoading)
export const plan = state => (state.auth.plan.data)
export const errorPlan = state => (state.auth.plan.error)

export const isLoadingSignUpMedico = state => (state.auth.signupMedico.isLoading)
export const errorSignUpMedico = state => (state.auth.signupMedico.error)
export const successSignUpMedico = state => (state.auth.signupMedico.success)

export const isLoadingRecoveryPasswd = state => (state.auth.recoveryPasswd.isLoading)
export const errorRecoveryPasswd = state => (state.auth.recoveryPasswd.error)
export const successRecoveryPasswd = state => (state.auth.recoveryPasswd.success)

export const isLogged = state => (state.auth.signin.isLogged)
export const loggedAt = state => (state.auth.signin.receivedAt)
export const jwtPayload = state => (state.auth.signin.jwtPayload)
export const jwt = state => (state.auth.signin.jwt)
